import Layout from 'components/Layout';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router';
import React, { useState } from 'react';

import {
  Card, Typography, Form, Input, Button, message,
} from 'antd';

import http, { getHttpErrorMessage } from 'utils/http';
import { captureException } from 'utils/errors';
import { WL_CONFIG } from 'constants';

const Logo = WL_CONFIG.logo.medium;

function ResetPassword() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (data) => {
    setLoading(true);
    http.post('user/rest-auth/password/reset/', data, {
      headers: {
        Authorization: '',
      },
    })
      .then((res) => {
        message.success('Please check your mail box.');
        navigate('/');
        setLoading(false);
      })
      .catch((e) => {
        captureException(e);
        setLoading(false);
        message.error(getHttpErrorMessage(e));
      });
  };

  return (
    <Layout hasSidebar={false}>
      <div className="w-screen h-screen flex items-center justify-center">
        <Card className="w-96">
          <div className="flex items-center justify-center mb-5">
            <Logo style={{ maxWidth: '100%' }} />
          </div>
          <Typography.Title level={1} className="mt-3" style={{ fontSize: 24 }}>
            Reset Password
          </Typography.Title>
          <Form
            onFinish={handleSubmit}
            className="mt-6"
            validateTrigger="onSubmit"
          >
            <Form.Item
              name="email"
              rules={[{ required: true, message: 'Please input your email!' }]}
            >
              <Input placeholder="email" />
            </Form.Item>

            <Link to="/login">Sign in with Email</Link>
            <Form.Item>
              <Button
                block
                loading={loading}
                disabled={loading}
                type="primary"
                htmlType="submit"
                className="mt-5"
              >
                Reset Password
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </Layout>
  );
}

export default ResetPassword;
